import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import locales from '../config/locales';

export const LANGUAGES = {
  TR: 'tr',
  EN: 'en'
};

const handleResources = (locale, lng) =>
  Object.keys(locale).reduce((acc, key) => {
    acc[key] = locale?.[key][lng];
    return acc;
  }, {});

const resourcesEN = handleResources(locales, LANGUAGES.EN);
const resourcesTR = handleResources(locales, LANGUAGES.TR);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: LANGUAGES.EN,
    resources: {
      tr: {
        translation: resourcesTR
      },
      en: {
        translation: resourcesEN
      }
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
